exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".DescriptiveContainer-local__container--KzGX6 {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  .DescriptiveContainer-local__container--KzGX6 span {\n    padding-left: 13px;\n    margin-top: 0.11em;\n    display: -ms-flexbox;\n    display: flex;\n    height: 15px;\n    font-size: 12px;\n    font-weight: normal; }\n    .DescriptiveContainer-local__container--KzGX6 span p:first-child {\n      color: #18a0fb;\n      margin-right: 0.3em;\n      font-weight: 500; }\n", ""]);

// exports
exports.locals = {
	"container": "DescriptiveContainer-local__container--KzGX6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/team/team/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src"]}!./src/components/Common/DescriptiveContainer/DescriptiveContainer.local.scss
// module id = 2270
// module chunks = 0